import React from 'react'
import styled from 'styled-components'
import cx from 'clsx'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Root = styled.div`
  display: grid;
  grid-template-areas: "title bookmark";
  gap: ${rem(4)};

  &.with-urgency-label {
    grid-template-areas:
      "urgency bookmark"
      "title title";

    &.booked-today {
      grid-template-areas:
          "title bookmark"
          "urgency bookmark";
      grid-template-columns: 1fr auto;
      gap: ${rem(8)};
      align-items: center;

      ${mediaQueryUp.sm} {
        grid-template-areas:
        "title urgency bookmark";
        grid-template-columns: 1fr auto auto;
      }
    }
  }
`

const TitleArea = styled.span`
  grid-area: title;
`

const BookmarkArea = styled.span`
  grid-area: bookmark;
  justify-self: end;
`

const UrgencyArea = styled.span`
  grid-area: urgency;
  &.booked-today {
    ${mediaQueryUp.sm} {
      justify-self: end;
    }
  }
`

interface Props {
  title?: React.ReactNode;
  bookmarkButton?: React.ReactNode;
  urgencyLabel?: React.ReactNode;
  bookedToday?: boolean;
}

const TitleGrid = ({ title, bookmarkButton, urgencyLabel, bookedToday }: Props) => {
  return (
    <Root className={cx(urgencyLabel && 'with-urgency-label', bookedToday && 'booked-today')}>
      <TitleArea>
        {title}
      </TitleArea>
      <BookmarkArea>
        {bookmarkButton}
      </BookmarkArea>
      {urgencyLabel && (
        <UrgencyArea className={cx(bookedToday && 'booked-today')}>
          {urgencyLabel}
        </UrgencyArea>
      )}
    </Root>
  )
}

export default TitleGrid
